import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-note-form',
  imports: [RmsModule],
  templateUrl: './note-form.component.html',
  styleUrl: './note-form.component.scss'
})
export class NoteFormComponent {
  Note: any = {};

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef) {
    this.Note = { ...data };
  }

  save() {
    this.ref.close({ ...this.Note, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
